import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build(
	"/admin/features",
	lazy(() => import("./AdminFeaturesPage"))
);